import useSWR from 'swr'
import API from '../../utils/api'
import { getPersistData } from '../../app/hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/transaction/deposit?page=1&maxData=99999999&userId=' // (3) 특정인 입금 목록 조회

let swrData: any = getPersistData(KEY)

export function useDepositList(userId) {
	const { data: token } = useToken()
	const { data, mutate } = useSWR<any>(
		KEY + userId,
		async () => {
			const response = await API.get(KEY + userId, token + '', {})
			swrData = response.result?.result?.list

			return swrData
		},
		{ revalidateOnFocus: true }
	)

	return {
		depositList: data,
		mutate: (value?: any) => {
			if (value != undefined) {
				swrData = value
			}
			return mutate()
		},
	}
}